import { take } from 'rxjs/operators';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TimeHlp } from 'src/lib/fliko/helpers/time.helper';
import { UserData } from 'src/lib/fliko/models/users/user.data';
import { AuthService } from 'src/app/shared/services/auth.service';
import { SnackBarService } from 'src/app/shared/services/snackBar.service';
import { PasswordValidators } from 'src/app/shared/validators/password.validators';
import { UserService } from 'src/app/view/users/services/user.service';

@Component({
  selector: 'app-renew-password',
  templateUrl: './renew-password.component.html',
  styleUrls: ['./renew-password.component.scss']
})
export class RenewPasswordComponent implements OnInit {
  public static readonly PERIOD_OF_VALIDITY = 60;
  public readonly NEW_VALIDITY_DATE = TimeHlp.add(Date.now(), RenewPasswordComponent.PERIOD_OF_VALIDITY, 'DAY');

  public form: FormGroup;

  PERIOD_OF_VALIDITY = RenewPasswordComponent.PERIOD_OF_VALIDITY;
  MIN_LENGTH = PasswordValidators.MIN_LENGTH;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: UserData,
    private dialogRef: MatDialogRef<RenewPasswordComponent>,
    private fb: FormBuilder,
    private authService: AuthService,
    private userService: UserService,
    private snackBarService: SnackBarService
  ) {
    this.form = this.fb.group({
      oldPassword: [null, Validators.required],
      newPassword: [null, [Validators.required, PasswordValidators.new('oldPassword'), PasswordValidators.policy]],
      confirmNewPassword: [null, [Validators.required, PasswordValidators.confirm('newPassword')]]
    });
  }

  ngOnInit(): void {}

  public async submit(): Promise<void> {
    if (this.form.valid) {
      const userId = this.authService.getCurrentUserUid();
      const userEmail = this.authService.getCurrentUserEmail();
      await this.authService.verifyUserCredentials(userEmail ?? '', this.form.value.oldPassword).then(
        (result) => {
          if (result) {
            this.authService.updatePassword(this.form.value.confirmNewPassword);
            this.userService
              .getUser$(userId ?? '')
              .pipe(take(1))
              .subscribe(async (user) => {
                if (user) await this.userService.setPasswordDate(user.id);
              });
            this.snackBarService.showSuccess('success.passwdChange');
            this.dialogRef.close();
          }
        },
        (reason) => this.snackBarService.showError('error.wrongPasswd', reason)
      );
    }
  }
}
